import gql from "graphql-tag.macro";

const loadActiveWorkflowModelQuery = gql`
    query loadActiveWorkflowModel {
        currentProject {
            ... on Project {
                _id
                activeWorkflowModel {
                    defaultDisabled
                    stages {
                        _id
                        name
                        description
                        nextStageTransitions {
                            to
                            name
                            description
                        }
                        prevStageTransitions {
                            to
                            name
                            description
                        }
                        PlannedDuration
                        onEnter {
                            explicit_deny {
                                subject
                                kind
                                permission
                                scope
                            }
                            createActions {
                                kind
                                name
                                customstati
                                subject {
                                    id
                                    kind
                                }
                            }
                        }
                        defaultActionType
                        exitguards {
                            nextStageId
                            conditions {
                                assertation {
                                    ... on ActionAssertation {
                                        customstatus
                                        type
                                        status
                                    }
                                }
                            }
                        }
                        autoprogress {
                            nextStageId
                            conditions {
                                assertation {
                                    ... on ActionAssertation {
                                        customstatus
                                        type
                                        status
                                    }
                                }
                            }
                        }
                    }
                    StartDate
                    description
                    name
                    _id
                }
            }
        }
    }
`;

const loadWorkflowInstancesUsingCurrentModelQuery = gql`
    query workflowinstances {
        workflowinstances (filter: { project: "CURRENT" }){
            edges {
                node {
                    _id
                    workflowmodelid
                }
            }
        }
    }
`;

const updateWorkflowModelMutation = gql`
    mutation updateWorkflowModel($input: WorkflowmodelInput!, $id: ID!) {
        updateWorkflowmodel(input: $input, id: $id) {
            stages {
                _id
                name
                description
                defaultActionType
                nextStageTransitions {
                    to
                    name
                    description
                }
                prevStageTransitions {
                    to
                    name
                    description
                }
                PlannedDuration
                onEnter {
                    explicit_deny {
                        subject
                        kind
                        permission
                        scope
                    }
                    createActions {
                        kind
                        name
                        customstati
                        subject {
                            id
                            kind
                        }
                    }
                }
                defaultActionType
                exitguards {
                    nextStageId
                    conditions {
                        assertation {
                            ... on ActionAssertation {
                                customstatus
                                type
                                status
                            }
                        }
                    }
                }
                autoprogress {
                    nextStageId
                    conditions {
                        assertation {
                            ... on ActionAssertation {
                                customstatus
                                type
                                status
                            }
                        }
                    }
                }
            }
            StartDate
            description
            name
            _id
        }
    }
`;

const applyWorkflowModelMutation = gql`
        mutation applyWorkflowModelChange($id: ID!, $workflowInstances: [ID!]!, $workflowstagemap: JSONObject) {
            applyWorkflowModelChange (workflowModel: $id, workflowInstances: $workflowInstances, workflowstagemap: $workflowstagemap){
              _id
              stages {
                _id
                name
              }
            }
    }
`;

const enableWorkflowInstancesMutation = gql`
        mutation enabledisableWorkflowInstance($workflowInstances: [ID!]!) {
            enabledisableWorkflowInstance (workflowInstances: $workflowInstances, enabled: true){
              _id
              disabled
              stages {
                _id
                name
              }
            }
    }
`;

export const loadWorkflowModel = async ({ client }) => {
    const {
        data: { currentProject: { activeWorkflowModel: data } = {} } = {},
    } = await client.query({
        query: loadActiveWorkflowModelQuery,
        fetchPolicy: "no-cache"
    });
    return data;
};

export const loadWorkflowInstances = async ({ modelId }, { client }) => {
    const {
        data: { workflowinstances: data } = {},
    } = await client.query({
        query: loadWorkflowInstancesUsingCurrentModelQuery,
        fetchPolicy: "no-cache"
    });
    return data;
};

export const activateWorkflowModel = async ({ model: { _id, ...model } }, { client }) => {
    const { data: { updateWorkflowmodel } = {} } = await client.mutate({
        mutation: updateWorkflowModelMutation,
        // eslint-disable-next-line no-underscore-dangle
        variables: { input: model, id: _id },
    });
    return updateWorkflowmodel;
};

export const updateWorkflowModel = async ({ model: { _id, ...model }, workflowInstances, deletedStageMap }, { client }) => {
    const { data: { updateWorkflowmodel } = {} } = await client.mutate({
        mutation: updateWorkflowModelMutation,
        // eslint-disable-next-line no-underscore-dangle
        variables: { input: model, id: _id },
    });

    const stagemapWithGeneratedIds = Object.fromEntries(Object.entries(deletedStageMap).map(([ deletedStage, newStage ]) => {
        const newStageIndex = model?.stages?.findIndex(({ _id: stageId }) => stageId === newStage);
        const newStageObj = newStageIndex && updateWorkflowmodel?.stages?.find((_, idx) => idx === newStageIndex);
        if (newStageObj?._id){
            return [ deletedStage, newStageObj._id ];
        }
        return [ deletedStage, newStage ];
    }));

    await client.mutate({
        mutation: enableWorkflowInstancesMutation,
        // eslint-disable-next-line no-underscore-dangle
        variables: { workflowInstances },
    });
    await client.mutate({
        mutation: applyWorkflowModelMutation,
        // eslint-disable-next-line no-underscore-dangle
        variables: { id: _id, workflowInstances, workflowstagemap: stagemapWithGeneratedIds },
    });
    return updateWorkflowmodel;
};
